import React from "react";
import { DateTimePicker } from "./DateTimePicker";

export class TimePicker extends React.Component {    
    render() {
        const { value, ...rest } = this.props;

        return <DateTimePicker
            {...rest}
            value={value}
            mode="date"
            display="clock"
        />
    }
}